import { persistExplorerProfileFromSession } from "./explorerProfileSync";
import {
  getExplorerLocalProfile,
  getExplorerPendingOnboarding,
} from "./explorerSession";

const OBJECTIVES_FOR_ATTENDING_KEY = "objectivesForAttending";

/**
 * Best-effort: persist segment + discovery via anonymous public-profile before the user
 * creates an account on the explorer password-signup screen. Does not alter the explorer wizard.
 */
export async function trySyncExplorerPublicProfileBeforeSignup(options: {
  /** Email on the register form — must match session step-1 profile or we skip (wrong row). */
  emailForSignup: string;
}): Promise<void> {
  const signupEmail = options.emailForSignup.trim().toLowerCase();
  if (!signupEmail) return;

  const local = getExplorerLocalProfile();
  if (!local || local.email.trim().toLowerCase() !== signupEmail) return;

  const pending = getExplorerPendingOnboarding();
  if (!pending?.segment) return;

  try {
    await persistExplorerProfileFromSession({
      segment: pending.segment,
      objectives: pending.discoveryAnswers?.[OBJECTIVES_FOR_ATTENDING_KEY] ?? "",
      discoveryAnswers: pending.discoveryAnswers,
    });
  } catch (err: unknown) {
    const code = (err as { response?: { data?: { code?: string } } })?.response
      ?.data?.code;
    if (code === "already_registered") return;
    // Do not block account creation if this fails (network, etc.).
  }
}
